import React from 'react';
import styles from './ThumbnailGrid.module.scss';
import {Thumbnail} from '../Thumbnail';
import {Props as ThumbnailProps} from '../Thumbnail';

interface Props {
  items: ThumbnailProps[]; //TODO: Change to accepting albums
}

export default function ThumbnailGrid({items}: Props) {
  // TODO: Replace temp onClick w/ link to album page
  const thumbnailMarkup = items.map((item) => (
    <Thumbnail key={item.name} {...item} />
  ));

  return <div className={styles.ThumbnailGrid}>{thumbnailMarkup}</div>;
}
